import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace('#', '?')).get('session_id');
    
    if (!sessionId) {
      navigate('/login');
      return;
    }

    const processSession = async () => {
      try {
        const res = await axios.post(`${API}/api/auth/google/callback`, { session_id: sessionId });
        const { token, ...userData } = res.data;
        login(userData, token);
        navigate('/app', { replace: true });
      } catch (err) {
        console.error('Auth callback error:', err);
        navigate('/login');
      }
    };

    processSession();
  }, [navigate, login]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground">Iniciando sesion...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
